module.exports = __webpack_public_path__ + "img/category-gift-vouchers.50da43cc.jpg";